
import React from 'react';
import Button from '../../../components/base/Button';

export default function EducationCTASection() {
  return (
    <section className="py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold text-[#111111] mb-6">
            Explore Education Initiatives
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-12">
            Join us in spreading life-saving knowledge about oxygen health. 
            Together, we can build healthier communities through education and awareness.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-2-line text-2xl text-[#12B6B6]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#111111] mb-3">Access Resources</h3>
              <p className="text-gray-600 mb-4">Download free educational materials and guides</p>
              <Button variant="outline" size="sm">
                Browse Library
              </Button>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-[#12B6B6]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#111111] mb-3">Join Workshops</h3>
              <p className="text-gray-600 mb-4">Participate in community training programs</p>
              <Button variant="outline" size="sm">
                Find Workshops
              </Button>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[#12B6B6]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-[#12B6B6]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#111111] mb-3">Stay Informed</h3>
              <p className="text-gray-600 mb-4">Subscribe to newsletters and updates</p>
              <Button variant="outline" size="sm">
                Subscribe Now
              </Button>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="primary" size="lg">
              Explore All Initiatives
            </Button>
            <Button variant="secondary" size="lg">
              Partner with Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
